import {
  Box,
  Card,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  DialogContent,
  DialogTitle,
  Dialog,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import {
  RiDeleteBin6Line,
  RiVerifiedBadgeFill,
  RiErrorWarningLine,
  RiEyeLine,
} from "react-icons/ri";
import { GrFormEdit } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DOCUMENT from "../../../assets/images/big/Group.png";
import { useTMutation } from "../../../utils/useTMutation";
import showToast from "../../../components/Hot-Toast/showToast";
import CloseIcon from "@mui/icons-material/Close";
import DeleteModal from "../../../components/PopupModal/DeleteModal";
import { setSelectedTabData } from "../../../slice/profileTabSectionSlice";
import { CircularProgressbar as ReactCircularProgressbar } from "react-circular-progressbar";
import { API_URL } from "../../../appConstants";
import { generatePDFThumbnail } from "../../../utils/generateThumbNail";
import { PictureAsPdf, Image as ImageIcon } from "@mui/icons-material";
import { formatDate } from "../../../utils/genericMethod";

const ClinicianExperience = ({ data }) => {
  const { selectedTabData } = useSelector((state) => state.profileTabSection);
  const resumeFilePath = selectedTabData?.about?.FILE_NAME;
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);
  const [userExperience, setUserExperience] = useState([]);
  const [referenceData, setReferenceData] = useState([]);
  const [formattedExpDates, setFormattedExpDates] = useState({});
  const { controlBy, controlAction, controlUser } = useSelector(
    (state) => state.user,
  );
  const AllViewControl =
    controlAction === "view" &&
    (controlBy === "facility" || controlBy === "admin");
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [deletePopup, setDeletePopup] = useState(false);
  const [pdfThumbnails, setPdfThumbnails] = useState({});
  useEffect(() => {
    if (selectedTabData?.workExperience) {
      setUserExperience(selectedTabData.workExperience);
    }
    if (selectedTabData?.referenceData) {
      setReferenceData(selectedTabData.referenceData);
    }
  }, [selectedTabData]);

  const [fileType, setFileType] = useState(null);
  const [open, setOpen] = useState(false);
  const [documentPath, setDocumentPath] = useState("");

  console.log("pdfThumbnails-----------", pdfThumbnails);

  const navigate = useNavigate();
  // const handleViewDocument = () => {
  //     const fileName = selectedTabData?.about?.FILE_NAME;

  //     // If trying to view and file is missing
  //     if (controlAction === 'view' && !fileName) {
  //         showToast('warning', 'Resume is missing')
  //         return;
  //     }
  //     let route = '/'
  //     if (controlAction === 'view' && controlBy === 'admin') {
  //         route = '/admin/clinician-users/view-resume';
  //     } else if (controlAction === 'view' && controlBy === 'facility') {
  //         route = '/facility/clinician-users/view-resume';
  //     }
  //     else if (controlAction === 'edit') {
  //         route = '/admin/clinician-users/edit-resume';
  //     }
  //     else {
  //         route = '/clinician/profile/uploadresume'
  //     }
  //     navigate(route)
  // }

  const handleViewDocument = () => {
    const fileName = selectedTabData?.about?.FILE_NAME;

    // If trying to view and file is missing
    if (controlAction === "view" && !fileName) {
      showToast("warning", "Resume is missing");
      return;
    }

    // ✅ Show modal popup only for admin in view mode
    if (controlAction === "view" && controlBy === "admin") {
      const ext = fileName.split(".").pop().toLowerCase();
      if (["pdf", "jpg", "jpeg", "png"].includes(ext)) {
        setFileType(ext);
        setDocumentPath(fileName);
        setOpen(true);
      } else {
        showToast("warning", "Unsupported file type");
      }
      return;
    }

    // ✅ Keep original routing for all other cases
    let route = "/";
    if (controlAction === "view" && controlBy === "facility") {
      const ext = fileName.split(".").pop().toLowerCase();
      if (["pdf", "jpg", "jpeg", "png"].includes(ext)) {
        setFileType(ext);
        setDocumentPath(fileName);
        setOpen(true);
      } else {
        showToast("warning", "Unsupported file type");
      }
      return;
    } else if (controlAction === "edit") {
      route = "/admin/clinician-users/edit-resume";
    } else {
      route = "/clinician/profile/uploadresume";
    }

    navigate(route);
  };

  const { mutateAsync } = useTMutation(
    "/deleteExperience",
    "delete",
    (data) => {
      return data;
    },
  );
  const handleDelete = async () => {
    const response = await mutateAsync({
      ID: selectedExperience.ID,
      USER_ID: userDetails?.ID,
    });
    if (response.STATUS) {
      showToast("success", response.MESSAGE, 3000);
      // Dispatch the updated selectedTabData to Redux
      dispatch(
        setSelectedTabData({
          ...selectedTabData,
          workExperience: response?.OUTPUT,
        }),
      );
    } else {
      showToast("error", response.MESSAGE, 5000);
    }
    setSelectedExperience({});
    setDeletePopup(false);
  };

  const closeDeleteModal = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setSelectedExperience({});
    setDeletePopup(false);
  };

  const handleResumeClose = () => setOpen(false);

  const handleResumeClick = () => {
    if (AllViewControl) {
      handleViewDocument();
    } else {
      // navigate("/upload/resume"); // Uncomment if navigation is needed
      handleViewDocument(); // Or trigger modal always for simplicity
    }
  };

  useEffect(() => {
    const formatAllDates = async () => {
      const formatted = {};
      for (let i = 0; i < userExperience.length; i++) {
        const exp = userExperience[i];
        // Check if To Date is empty, null, or whitespace-only
        const isCurrentlyWorking = !exp.EXP_TO_DATE || exp.EXP_TO_DATE === "" || (typeof exp.EXP_TO_DATE === "string" && exp.EXP_TO_DATE.trim() === "");
        
        let toDate = "Present";
        if (!isCurrentlyWorking) {
          const formattedToDate = await formatDate(exp.EXP_TO_DATE);
          // If the formatted date is empty, "Invalid Date", or invalid, show "Present"
          if (!formattedToDate || formattedToDate.toLowerCase().includes("invalid")) {
            toDate = "Present";
          } else {
            toDate = formattedToDate;
          }
        }
        
        formatted[i] = {
          from: exp.EXP_FROM_DATE ? await formatDate(exp.EXP_FROM_DATE) : "",
          to: toDate,
        };
      }
      setFormattedExpDates(formatted);
    };
    formatAllDates();
  }, [userExperience]);

  useEffect(() => {
    const ext = resumeFilePath?.split(".").pop().toLowerCase();
    if (resumeFilePath && ext === "pdf") {
      const loadThumbnail = async () => {
        const thumb = await generatePDFThumbnail(
          `${API_URL}user/viewFile?fileName=${resumeFilePath}`,
        );
        setPdfThumbnails({ resume: thumb });
      };
      loadThumbnail();
    }
  }, [resumeFilePath]);

  return (
    <>
      <Card sx={{ padding: "20px", marginTop: 2 }}>
        <Grid container display="flex" justifyContent={"space-between"}>
          <Grid item style={{ marginBottom: "-5px" }}>
            <Typography variant="h3" className="about_text_black">
              Experience
            </Typography>
            <Typography variant="body1" className="desc-text" mt={1}>
              An overview showcasing the clinician's work experience.
            </Typography>
          </Grid>
          <Grid style={{ marginTop: "-5px" }}>
            {!AllViewControl && (
              <Tooltip title="Add Experience">
                <Grid item>
                  <AddIcon
                    onClick={() => {
                      if (controlAction === "edit" && controlBy === "admin") {
                        navigate("/admin/clinician-users/add-experience");
                      } else {
                        navigate("/clinician/profile/add-experience");
                      }
                    }}
                    sx={{
                      // color: "linear-gradient(to right,#6ebe44,#4eb3e8)",

                      color: "#6ebe44",

                      cursor: "pointer",
                    }}
                    fontSize="large"
                  />
                </Grid>
              </Tooltip>
            )}
          </Grid>
        </Grid>

        {userExperience &&
          userExperience?.map((experience, index) => (
            <>
              <Box
                mt={-0.4}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box>
                  <Typography variant="h6" fontWeight={600}>
                    {formattedExpDates[index]?.from || ""} -{" "}
                    {formattedExpDates[index]?.to || "Present"}
                  </Typography>
                </Box>
                <Box display="flex" gap={1}>
                  {!AllViewControl && (
                    <Tooltip title="Edit">
                      <IconButton>
                        <GrFormEdit
                          sx={{ color: "#6ebe44" }}
                          onClick={() => {
                            if (
                              controlAction == "edit" &&
                              controlBy == "admin"
                            ) {
                              navigate(
                                `/admin/clinician-users/add-experience?${new URLSearchParams(
                                  { EXP_ID: experience?.ID },
                                ).toString()}`,
                              );
                            } else {
                              navigate(
                                `/clinician/profile/add-experience?${new URLSearchParams(
                                  { EXP_ID: experience?.ID },
                                ).toString()}`,
                              );
                            }
                          }}
                          className="edit-icon"
                        />
                      </IconButton>
                    </Tooltip>
                  )}

                  {!AllViewControl && (
                    <Tooltip title="Delete">
                      <IconButton>
                        <RiDeleteBin6Line
                          style={{
                            color: "#ff0000",
                            width: "18px",
                            height: "18",
                          }}
                          onClick={() => {
                            setSelectedExperience(experience);
                            setDeletePopup(true);
                          }}
                          className="delete-icon"
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </Box>

              <Box
                lg={12}
                sx={{ backgroundColor: "#f5f5f5", padding: "5px 15px" }}
              >
                <Typography variant="body2" component="p">
                  <strong>Facility:</strong>{" "}
                  <span
                    style={{
                      padding: "5px 28px",
                      // color: "#000000",
                      opcity: "87%",
                      fontWeight: 500,
                    }}
                  >
                    {" "}
                    {experience?.EXP_FACILITY_NAME || ""}
                  </span>
                </Typography>
                <Typography variant="body2" component="p">
                  <strong>Specialty:</strong>{" "}
                  <span
                    style={{
                      padding: "5px 15px",
                      // color: "#000000",
                      opcity: "87%",
                      fontWeight: 500,
                    }}
                  >
                    {" "}
                    {experience?.EXP_SPECIALTY_NAME}
                  </span>
                </Typography>
                <Typography variant="body2" component="p">
                  <strong>Date:</strong>{" "}
                  <span
                    style={{
                      padding: "5px 42px",
                      // color: "#000000",
                      opcity: "87%",
                      fontWeight: 500,
                    }}
                  >
                    {formattedExpDates[index]?.from || ""} -{" "}
                    {formattedExpDates[index]?.to || "Present"}
                  </span>
                </Typography>
                <Typography variant="body2" component="p">
                  <strong>Location:</strong>{" "}
                  <span
                    style={{
                      padding: "5px 17px",
                      // color: "#000000",
                      opcity: "87%",
                      fontWeight: 500,
                    }}
                  >
                    {experience?.EXP_STREET_ADDRESS}{" "}
                  </span>
                </Typography>

                <Typography variant="body2" component="p">
                  <strong>Type:</strong>{" "}
                  <span
                    style={{
                      padding: "5px 42px",
                      // color: "#000000",
                      opcity: "87%",
                      fontWeight: 500,
                    }}
                  >
                    {experience?.EXP_TYPE}
                  </span>
                </Typography>
              </Box>
            </>
          ))}
      </Card>
      <Card sx={{ padding: "20px", marginTop: 2 }}>
        <Grid container display="flex" justifyContent={"space-between"}>
          <Grid item>
            <Typography variant="h3" className="about_text_black">
              Reference
            </Typography>
          </Grid>
        </Grid>

        {referenceData && (
          <Box>
            {/* commented by Anuj 10Apr */}
            <Box display="flex" justifyContent="space-between">
              <Box style={{ marginTop: "10px" }}>
                <Typography variant="h6" fontWeight={600}>
                  {referenceData?.REFERENCE_WORKING_FROM_DATE || ""} -{" "}
                  {referenceData?.REFERENCE_WORKING_TO_DATE || ""}
                </Typography>
              </Box>

              <Box mt={-0.4}>
                {!AllViewControl && (
                  <Tooltip title="Edit">
                    <IconButton>
                      <GrFormEdit
                        sx={{ color: "#6ebe44" }}
                        onClick={() => {
                          if (controlAction == "edit" && controlBy == "admin") {
                            navigate(`/admin/clinician-users/edit-reference`);
                          } else {
                            navigate("/clinician/profile/add-refernce");
                          }
                        }}
                        className="edit-icon"
                      />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Box>
            <Box
              mt={0.1}
              sx={{ backgroundColor: "#f5f5f5", padding: "5px 15px" }}
            >
              {/* Added Reference Fields */}
              <Typography variant="body2" component="p">
                <strong>Reference Name:</strong>
                <span
                  style={{
                    padding: "5px 15px",
                    // color: "#000000",
                    opacity: "87%",
                    fontWeight: 500,
                  }}
                >
                  {referenceData?.REFERENCE_FIRST_NAME || ""}{" "}
                  {referenceData?.REFERENCE_LAST_NAME || ""}
                </span>
              </Typography>
              <Typography variant="body2" component="p">
                <strong>Reference Facility:</strong>
                <span
                  style={{
                    padding: "5px 15px",
                    // color: "#000000",
                    opacity: "87%",
                    fontWeight: 500,
                  }}
                >
                  {referenceData?.REFERENCE_FACILITY_NAME || ""}
                </span>
              </Typography>
              <Typography variant="body2" component="p">
                <strong>Reference Email:</strong>
                <span
                  style={{
                    padding: "5px 15px",
                    // color: "#000000",
                    opacity: "87%",
                    fontWeight: 500,
                  }}
                >
                  {referenceData?.REFERENCE_EMAIL_ADDRESS || ""}
                </span>
              </Typography>
            </Box>
          </Box>
        )}
      </Card>

      <Card sx={{ padding: "20px", marginTop: 2 }}>
        <Grid container display="flex" justifyContent={"space-between"}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h3" className="about_text_black">
              Resume
            </Typography>
            <Typography variant="body1" className="desc-text" mt={1}>
              Attach your resume to share your qualifications and experience.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} display="flex" justifyContent={"flex-end"}>
            <div style={{ width: 42, height: 42 }}>
              <ReactCircularProgressbar
                text={resumeFilePath ? "1/1" : "0/1"}
                value={100}
                styles={{
                  path: { stroke: resumeFilePath ? "#6ebe44" : "#BDBDBD" },
                  text: {
                    fill: resumeFilePath ? "#6ebe44" : "#BDBDBD",
                    fontSize: "30px",
                    fontFamily: "Inter",
                    fontWeight: "500",
                    lineHeight: "13.31px",
                  },
                  trail: { stroke: "#d6d6d6" },
                }}
              />
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ justifyContent: "flex-start" }}>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Card
              sx={{
                padding: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: 150,
                textAlign: "left",
                position: "relative",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              className="card-container"
              onClick={handleResumeClick}
            >
              {/* Thumbnail Box */}
              {/* <Box
                  sx={{
                    width: "100%",
                    height: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    position: "relative",
                  }}
                >
                  {(() => {
                    const path = resumeFilePath;
                    const ext = path?.split(".").pop().toLowerCase();

                    if (ext === "pdf") {
                      return (
                        <embed
                          src={`${API_URL}user/viewFile?fileName=${path}`}
                          type="application/pdf"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      );
                    } else if (["jpg", "jpeg", "png"].includes(ext)) {
                      return (
                        <img
                          src={`${API_URL}user/viewFile?fileName=${path}`}
                          alt="Image Thumbnail"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      );
                    } else {
                      return (
                        <img
                          src={DOCUMENT}
                          alt="Default Document"
                          style={{ width: "60%", height: "60%" }}
                        />
                      );
                    }
                  })()}
                </Box> */}

              <Box
                sx={{
                  width: "100%",
                  height: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "hidden",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  position: "relative",
                }}
              >
                {(() => {
                  const path = resumeFilePath;
                  const ext = path?.split(".").pop()?.toLowerCase();

                  if (!path) {
                    return (
                      <img
                        src={DOCUMENT}
                        alt="Default Document"
                        style={{ width: "60%", height: "60%" }}
                      />
                    );
                  }

                  if (ext === "pdf") {
                    return (
                      <PictureAsPdf sx={{ fontSize: 40, color: "#f44336" }} />
                    );
                  }

                  if (["jpg", "jpeg", "png"].includes(ext)) {
                    return (
                      <ImageIcon sx={{ fontSize: 40, color: "#2196f3" }} />
                    );
                  }

                  return (
                    <img
                      src={DOCUMENT}
                      alt="Default Document"
                      style={{ width: "60%", height: "60%" }}
                    />
                  );
                })()}
              </Box>

              {/* Eye Icon */}
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography variant="body2">
                  <RiEyeLine style={{ fontSize: 32 }} />
                </Typography>
              </Box>

              {/* Upload Status Icon */}
              <Tooltip title={resumeFilePath ? "Uploaded" : "Missing File"}>
                <IconButton
                  sx={{
                    position: "absolute",
                    bottom: 10,
                    right: 10,
                    padding: 0,
                  }}
                >
                  {resumeFilePath ? (
                    <RiVerifiedBadgeFill color="#6ebe44" />
                  ) : (
                    <RiErrorWarningLine color="#EA4933" />
                  )}
                </IconButton>
              </Tooltip>
            </Card>
          </Grid>
        </Grid>

        {open && (
          <Dialog
            open={open}
            onClose={handleResumeClose}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle
              sx={{
                m: 0,
                p: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              View Resume
              <IconButton
                aria-label="close"
                onClick={handleResumeClose}
                sx={{ color: (theme) => theme.palette.grey[500] }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {fileType === "pdf" ? (
                <iframe
                  src={`${API_URL}user/viewFile?fileName=${documentPath}`}
                  width="100%"
                  height="700px"
                  title="Clinician Document"
                  style={{ border: "none" }}
                />
              ) : (
                <img
                  src={`${API_URL}user/viewFile?fileName=${documentPath}`}
                  alt="Clinician Document"
                  style={{ maxWidth: "100%", maxHeight: "600px" }}
                />
              )}
            </DialogContent>
          </Dialog>
        )}

        {deletePopup && (
          <DeleteModal
            open={deletePopup}
            onClose={closeDeleteModal}
            handleDelete={handleDelete}
            selectedItem={
              selectedExperience?.EXP_SPECIALTY_NAME + " Experience"
            }
          />
        )}
      </Card>
    </>
  );
};
ClinicianExperience.propTypes = {
  data: PropTypes.object.isRequired,
};
export default ClinicianExperience;
